import http from "@/services/http";
import {useAuth} from "@/services/auth.js";

export const fornecedores = () => {
  const auth = useAuth();

  async function list() {
    let retorno;
    try {
        const {data} = await http.get('/suppliers', auth.getBearer());
        retorno = data;
      } catch (error) {
        console.log(error?.response?.data);
      }
    return retorno;
  }

  async function createItem(fornecedor) {
    try {
      const {data} = await http.post('/suppliers', fornecedor, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  async function deleteItem(id) {
    try {
      const {data} = await http.delete('/suppliers/'+id, auth.getBearer());
      return true;
    } catch (error) {
      return false;
      console.log(error?.response?.data);
    }
  }

  async function updateItem(fornecedor) {
    try {
      const {data} = await http.put('/suppliers/'+fornecedor.id, fornecedor, auth.getBearer());
      return true;
    } catch (error) {
      return false;
      console.log(error?.response?.data);
    }
  }

  return {list, createItem, deleteItem, updateItem}
}
